import React from 'react';
import { BrowserRouter as Router, Route, Switch, Redirect, withRouter } from 'react-router-dom';
import { withOktaAuth } from '@okta/okta-react';
import { withUserContext } from '../contexts/UserContext';
import UserRoleManagement from '../pages/UserManagement/UserManagement';
import ScripterLandingPage from '../components/ScripterLandingPage/ScripterLandingPage';
import SubmissionDetailContainer from '../components/Views/Submissions/SubDetails/SubmissionDetailContainer';
import DealsDetails from '../components/Views/Deals/DealDetails/DealDetails';
import WeekendReadDetailsView from '../components/Views/WeekendRead/WeekendReadDetailView/WeekendReadDetailView';
import ProjectDetails from '../components/Views/Project/ProjectDetails/ProjectDetails';
import AdvancedSearch from '../components/Navigation/AdvancedSearch/AdvancedSearch';
import AccessDenied from '../components/AccessDenied/AccessDenied';

export default withOktaAuth(withUserContext(class Routes extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      activeTab:null,
      savedFilterObj: null,
      isLoadingWithFilters: false,
      savedFilterChips: [],
      dropDownValues:[],
      filterConfig:null,
      currentTablePage:1,
      sortBy:"Value",
      isSortByAsc:true,
      sortCount:0,
      lastVisitedURL: null
    }
  }
  updateFilterList = (filterToSave, filterValue) => {
    switch (filterToSave) {
      case "activeTab":
          this.setState({activeTab:filterValue})
        break;
        case "savedFilterObj":
          this.setState({savedFilterObj:filterValue})
        break;
        case "isLoadingWithFilters":
          this.setState({isLoadingWithFilters:filterValue})
        break;
        case "dropDownValues":
          this.setState({dropDownValues:filterValue})
        break;
        case "savedFilterChips":
          this.setState({savedFilterChips:filterValue})
        break;
        case "filterConfig":
          this.setState({filterConfig:filterValue})
        break;
        case "sortBy":
          this.setState({sortBy:filterValue})
        break;
        case "isSortByAsc":
          this.setState({isSortByAsc:filterValue})
        break;
        case "sortCount":
          this.setState({sortCount:filterValue})
        break;
        case "lastVisitedURL":
          this.setState({lastVisitedURL:filterValue})
        break;
    }
  }
  render() {
    let permissions = this.props.userContext?.active_tenant?.permissions;
    return (
      <Switch>
        {
          // permissions?.canAccessURM ? (
          //   <Route exact={true} path='/' render={(props) => <UserRoleManagement {...props} />} />
          // ) : (
          <>            
            <Route exact={true} path={["/", "/Submissions", "/Projects", "/Deals", "/WeekendRead", "/MyQueue"]} render={(props) => <ScripterLandingPage {...props} updateFilterList = {this.updateFilterList.bind(this)} savedFilterObj={this.state?.savedFilterObj} isLoadingWithFilters = {this.state?.isLoadingWithFilters} savedFilterChips = {this.state?.savedFilterChips} dropDownValues={this.state?.dropDownValues} filterConfig = {this.state?.filterConfig} activeTab={this.state?.activeTab} sortBy={this.state?.sortBy} isSortByAsc={this.state?.isSortByAsc} sortCount={this.state?.sortCount} lastVisitedURL={this.state?.lastVisitedURL}  />} />
            <Route exact={true} path='/submissionDetails/:id' render={(props) => <SubmissionDetailContainer {...props} {...this.props.functions}
              refreshPage={this.props?.refreshPage} 
              toggleRefreshPage={this.props?.toggleRefreshPage} updateFilterList = {this.updateFilterList.bind(this)} />} />
            <Route exact={true} path='/dealDetails/:id' render={(props) =><DealsDetails {...props} {...this.props.functions} refreshPage={this.props.refreshPage}
              toggleRefreshPage={this.props.toggleRefreshPage} updateFilterList = {this.updateFilterList.bind(this)} savedFilterObj={this.state?.savedFilterObj} isLoadingWithFilters = {this.state?.isLoadingWithFilters} savedFilterChips = {this.state?.savedFilterChips} dropDownValues={this.state?.dropDownValues} filterConfig = {this.state?.filterConfig} activeTab={this.state.activeTab} />} />
            <Route exact={true} path='/weekendReadDetails/:id' render={(props) => permissions.canViewWeekendRead ? <WeekendReadDetailsView {...props} {...this.props.functions} refreshPage={this.props.refreshPage} toggleRefreshPage={this.props.toggleRefreshPage} updateFilterList = {this.updateFilterList.bind(this)} /> : <AccessDenied />} />

            <Route exact={true} path='/projectDetails/:id' render={(props) => <ProjectDetails {...props} {...this.props.functions}
              refreshPage={this.props.refreshPage}
              toggleRefreshPage={this.props.toggleRefreshPage} updateFilterList = {this.updateFilterList.bind(this)} />} />
            <Route exact={true} path='/advancedSearch' render={(props) => <AdvancedSearch {...props} {...this.props.functions} />} />
            <Route exact={true} path='/userRoleManagement' render={(props) => <UserRoleManagement {...props} />} />
          </>
          // )
        }
      </Switch>
    );
  }
}
));